import createSupabaseStore from './supabase-table-store'

export default projectId => createSupabaseStore(
  async (set, supabase, payload) => {
    const {data} = await supabase
      .from('project_live_view')
      .select('*')
      .eq('project_id', projectId)
    ;

    set(data.reduce((cum, l) => {
      cum[l.player_id] = {[l.map_id]: l};
      return cum;
    }, {}));
  },
  'scores',
  {}
);